import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import "./TopBar.scss";
import { BREADCRUMB_PARENT, PAGE_TITLES } from "utils/constant/menu";

interface TopBarProps {
  onLogout: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = location.pathname.replace(/^\//, "").split("/")[0];

  const parent = BREADCRUMB_PARENT[currentPage];
  const title = PAGE_TITLES[currentPage] ?? "";

  return (
    <header className="topbar">
      <div className="topbar__breadcrumb">
        <span className="topbar__breadcrumb-home">홈</span>
        {parent && (
          <>
            <span className="topbar__breadcrumb-sep">›</span>
            <span className="topbar__breadcrumb-parent">{parent}</span>
          </>
        )}
        <span className="topbar__breadcrumb-sep">›</span>
        <span className="topbar__breadcrumb-current">{title}</span>
      </div>

      <div className="topbar__right">
        <button className="topbar__icon-btn" title="홈" onClick={() => navigate("/")}>
          ⌂{/* <span className="topbar__notif-dot" /> */}
        </button>
        <button className="topbar__logout" onClick={onLogout}>
          로그아웃
        </button>
      </div>
    </header>
  );
};

export default TopBar;
